import { FormGroup } from '@components/molecules/form/FormGroup';
import { Input } from '@components/atoms/Input';
import { TextareaInput } from '@components/atoms/TextareaInput';
import { InputCurrency } from '@components/atoms/InputCurrency';
import { Card } from '@components/atoms/Card';
import { useState } from 'react';
import { InputPhone } from '@components/atoms/InputPhone';

export const InputGroup = () => {
  const [price, setPrice] = useState<number | null>(null);
  const [budget, setBudget] = useState<number | null>(1500.5);
  const [amount, setAmount] = useState<number | null>(null);
  return (
    <Card>
      <div className="flex flex-col gap-4">
        <h2 className="text-lg font-bold text-gray-900 dark:text-white">
          Inputs
        </h2>
        <div className="flex flex-col">
          <Input placeholder="Add a new client" />
        </div>

        <h2 className="text-lg font-bold text-gray-900 dark:text-white">
          Inputs with FormGroup
        </h2>
        <div className="flex flex-col">
          <FormGroup label="Client Name" htmlFor="clientName">
            <Input placeholder="Add client name" id="clientName" />
          </FormGroup>
        </div>
        <div className="flex grid-cols-2 gap-2">
          <FormGroup label="Client Name" htmlFor="clientName">
            <Input placeholder="Add client name" id="clientName" />
          </FormGroup>
          <FormGroup
            error="Client name is required"
            label="Client Name"
            htmlFor="clientName">
            <Input placeholder="Add client name" id="clientName" />
          </FormGroup>
        </div>
        <div className="flex flex-col">
          <FormGroup label="Date" htmlFor="date">
            <Input type="date" placeholder="Add date" id="date" />
          </FormGroup>
        </div>
        <h2 className="text-lg font-bold text-gray-900 dark:text-white">
          Textarea Inputs
        </h2>
        <div className="flex flex-col gap-4">
          <FormGroup label="Description" htmlFor="description">
            <TextareaInput
              placeholder="Enter description..."
              id="description"
              rows={4}
            />
          </FormGroup>

          <FormGroup
            error="Description is required"
            label="Description"
            htmlFor="descriptionError">
            <TextareaInput
              placeholder="Enter description..."
              id="descriptionError"
              rows={4}
              error={true}
            />
          </FormGroup>
        </div>

        <div className="flex flex-col gap-4">
          <FormGroup label="Description" htmlFor="description">
            <TextareaInput
              placeholder="Enter description..."
              id="description"
              rows={4}
            />
          </FormGroup>

          <FormGroup label="Phone" htmlFor="phone">
            <InputPhone
              name="phone"
              value="1234567890"
              country="us"
              setFieldValue={(field, value) => {
                console.log('Phone changed:', field, value);
              }}
              placeholder="Enter description..."
            />
          </FormGroup>
        </div>

        <h2 className="text-lg font-bold text-gray-900 dark:text-white">
          Currency Inputs
        </h2>
        <div className="flex flex-col gap-4">
          <FormGroup label="Price" htmlFor="price">
            <InputCurrency
              placeholder="0.00"
              id="price"
              value={price}
              onValueChange={(value) => {
                setPrice(value);
                console.log('Price changed:', value);
              }}
            />
          </FormGroup>

          <FormGroup label="Budget" htmlFor="budget">
            <InputCurrency
              placeholder="0.00"
              id="budget"
              currency="USD"
              locale="en-US"
              value={budget}
              onValueChange={(value) => {
                setBudget(value);
                console.log('Budget changed:', value);
              }}
            />
          </FormGroup>

          <FormGroup
            error="Amount is required"
            label="Amount"
            htmlFor="amountError">
            <InputCurrency
              placeholder="0.00"
              id="amountError"
              value={amount}
              error={true}
              onValueChange={(value) => {
                setAmount(value);
                console.log('Amount changed:', value);
              }}
            />
          </FormGroup>

          {/* Display current values */}
          <div className="mt-2 p-2 bg-gray-50 dark:bg-gray-800 rounded-md">
            <h3 className="text-sm font-semibold text-gray-900 dark:text-white mb-2">
              Current Values:
            </h3>
            <div className="text-sm text-gray-600 dark:text-gray-300 space-y-1">
              <div>
                Price: {price !== null ? `$${price.toFixed(2)}` : 'Not set'}
              </div>
              <div>
                Budget: {budget !== null ? `€${budget.toFixed(2)}` : 'Not set'}
              </div>
              <div>
                Amount: {amount !== null ? `$${amount.toFixed(2)}` : 'Not set'}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
};
